<template>
  <el-form>
    <el-form-item class="mb-1">
      <el-input
        v-if="!codePrefilled"
        v-model="c"
        maxlength="8"
        placeholder="Enter code"
        show-word-limit
      />
    </el-form-item>

    <el-form-item class="mb-1">
      <el-input
        v-if="!emailPrefilled"
        v-model="e"
        placeholder="Enter email"
      />
    </el-form-item>

    <el-form-item class="mb-0">
      <el-input
        v-model="p"
        placeholder="Enter password"
        show-password
      />

      <PasswordMeter
        v-model="p"
        strength-meter-class="Password__strength-meter mb-0"
        :strength-meter-only="true"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import PasswordMeter from 'vue-password-strength-meter'

export default {
  components: {
    PasswordMeter
  },
  props: {
    code: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      codePrefilled: false,
      emailPrefilled: false
    }
  },
  computed: {
    c: {
      get: function () {
        return this.code
      },
      set: function (value) {
        this.$emit('update:code', value)
      }
    },
    e: {
      get: function () {
        return this.email
      },
      set: function (value) {
        this.$emit('update:email', value)
      }
    },
    p: {
      get: function () {
        return this.password
      },
      set: function (value) {
        this.$emit('update:password', value)
      }
    }
  },
  created () {
    if (this.code) {
      this.codePrefilled = true
    }

    if (this.email) {
      this.emailPrefilled = true
    }
  }
}
</script>
